module.exports = __webpack_public_path__ + "img/28.1a22a6db.jpg";